import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, Id, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../shared/types/permission";
import { targetGroupService } from "../shared/api/targetGroupService";

interface Props {
	targetGroupId: Id;
	handleEdit: () => void;
	handleDelete: () => Promise<any>;
}

export const TargetGroupListContextMenu: FC<Props> = ({ targetGroupId, handleEdit, handleDelete }) => {
	const { t } = useTranslation();

	const showUsageAction = useCallback(
		() => targetGroupService.showUsage(targetGroupId).then((r) => r.data.data),
		[targetGroupId],
	);

	const canUpdate = useHasPermission<PermissionName>(["targetGroup.update"]);
	const canDelete = useHasPermission<PermissionName>(["targetGroup.delete"]);

	return (
		<>
			<ContextMenu displayShortcutsAs="icon">
				{canUpdate && (
					<ContextMenuItem label={t("Edit")} action={handleEdit} title={t("Edit")} icon="edit" shortcut="primary" />
				)}
				{canDelete && (
					<ContextMenuDeleteWithModelUsageItem
						label={t("Delete")}
						title={t("Delete")}
						showUsageAction={showUsageAction}
						modelName={t("Target group")}
						confirmationBody={t("Are you sure you want to delete this target group?")}
						deleteAction={handleDelete}
						shortcut="danger"
					/>
				)}
			</ContextMenu>
		</>
	);
};
